import React,{Component} from 'react';

import './DataMaintenance.css';

import { background_5, image3 } from '../../theme/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import Tabs from '@acri-tools/react-tools/components/Tabs/Tabs';

import { isAdmin } from '@acri-tools/react-tools/utils/_user_manager/login';
import Modal, { ModalClose } from '@acri-tools/react-tools/components/Modal/Modal';
import CreateDataMaintenance from '../../components/CreateDataMaintenance/CreateDataMaintenance';
import DataMaintenancesSearch from '../../components/DataMaintenancesSearch/DataMaintenancesSearch';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL, get_page_title } from '../../utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { Helmet } from 'react-helmet';

interface Props{
}
interface State{
    modal_open: boolean
    loading?:boolean
    data?:any
}

export default class DataMaintenance extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            modal_open: false,
        }
    }


    componentDidMount(){
        this.fetch_data(true);
    }


    fetch_data = async (load?:boolean) => {
        if(load) this.setState({ loading: true });
        try {
            let res = await request(`${API_URL}/api/v1/data_maintenances`, {
                method: 'get',
                params:{
                    // filter: `type eq '${this.props.type}'`
                    orderby: 'data_id DESC',
                    // orderby: 'creation_date DESC',
                    limit: "null"
                }
            })

            // console.debug("data", res.data);

            // flattens data for DataTable
            let data:any = {
                DCR:[],
                service_request:[]
            };
            for(let d of res.data.value){
                data[d.type]?.push({ ...d, ...d.data });
            }

            this.setState({ data });
            // this.setState({ data: res.data?.value?.map((d:any)=>{ return { ...d, ...d.data } }) });
        }
        catch (e) {
            axiosErrorHandler(e, { functionName: `fetch_data` });
            toast_request_error(e);
        }
        finally {
            if(load) this.setState({ loading: false })
        }
    }
    
    data_tab = (type:'service_request'|'DCR') =>{
        if(this.state.loading) return (
            <div className="centered">
                <Spinner/>
            </div>
        ) 
        if(!this.state.data?.[type]) return (
            <div className="centered">
                <div className="no-data">NO DATA</div>
            </div>
        ) 
        return <div className="data-maintenance-tab">
            <DataMaintenancesSearch type={type} data={this.state.data[type]} reload_data={()=>{ this.fetch_data() } }/>
        </div>
    }

    render(){
        let tabs = [
            {
                label: <>Governed by Service requests</>,
                content: this.data_tab('service_request')
            },
            {
                label: <>Governed by DCR</>,
                content: this.data_tab('DCR')
            }
        ]
        return (
        <Page 
            id="data-maintenance"
            banner={{
                title: "Data Maintenance",
                bannerImage: background_5,
                topBar: true
            }}
            footer
        >
            <Helmet>
                <title>{ get_page_title('DAMPS - Data Maintenance') }</title>
                <meta 
                    name="description" 
                    content="The DAMPS data maintenance"
                />
            </Helmet>
            <div className="page-content">
                <div className="centered-content padding">
                    {
                        isAdmin() &&
                        <>
                            {/* ==============================
                                CREATE 
                                ============================== */}
                            <div 
                                className="custom-button blue inline medium"
                                onClick={()=>{ this.setState({ modal_open: true }) }}
                            >
                                <i className="fas fa-plus"/> ADD DATA MAINTENANCE
                            </div>
                            <br/>
                            <br/>

                            <Modal
                                className="medium"
                                opened={this.state.modal_open}
                                close={()=>{ this.setState({ modal_open: false }) }}
                            >
                                <div className="modal-title">
                                    ADD NEW DATA MAINTENANCE <ModalClose close={()=>{ this.setState({ modal_open: false }) }}/>
                                </div>
                                <div className="modal-content">
                                    <CreateDataMaintenance
                                        onCreate={()=>{
                                            // this.fetch_data();
                                            this.setState({ modal_open: false });
                                            this.fetch_data();
                                        }}
                                    />
                                </div>
                            </Modal>

                        </>
                    }


                    <Tabs
                        tabs={tabs}
                    />

                </div>
            </div>
        </Page>
        );
    }

    data_maintenances_table = (data_maintenances:Array<any>) =>{
        if(!(data_maintenances?.length > 0)){
            return (
                <div className="no-data">No orders</div>
            )
        }
        return (
            <div className="data-maintenance-table">
                
            </div>
        )
    }
};

